module.exports = __webpack_public_path__ + "static/media/create_sections_duplicate_section.6490120f.mov";